import NaptimeResource from './NaptimeResource';

type GetEnterpriseSelfServeContractProductPriceParams = {
  userLimit: number;
  billingType: number;
  enterprisePromotionId?: string;
  termInstallmentsTotal: number;
  userIdOpt?: number;
};

type GetEnterpriseSelfServeContractProductPriceQueryParams = {
  userLimit: number;
  billingType: 'ONE_TIME' | 'QUARTERLY';
  enterprisePromotionId?: string;
  termInstallmentsTotal: number;
  userIdOpt?: number;
};

type ComputeInvoiceBilledContractPriceParams = {
  userLimit: number;
  billingType: number;
  countryIsoCode: string;
};

class EnterpriseSelfServeContractProductPrices extends NaptimeResource {
  static RESOURCE_NAME = 'enterpriseSelfServeContractProductPrices.v1';

  static getPriceForEnterpriseContract(_billingType: number, userLimit: number) {
    let billingType;

    if (_billingType === 1) billingType = 'ONE_TIME';
    if (_billingType === 4) billingType = 'QUARTERLY';

    return this.get(`${userLimit}~${billingType}`, {
      fields: [
        'unitPrice',
        'rawLocalAmountTotal',
        'discountPercent',
        'countryIsoCode',
        'actualLocalAmountDueToday',
        'actualLocalAmountTotal',
        'rawLocalAmountDueToday',
        'actualLocalDiscountedAmount',
        'fxRateId',
        'rawAmountTotal',
        'rawAmountDueToday',
        'id',
        'currencyCode',
      ],
    });
  }

  static computeInvoiceBilledContractPrice({
    userLimit,
    billingType,
    countryIsoCode,
  }: ComputeInvoiceBilledContractPriceParams) {
    return this.finder('computeInvoiceBilledContractPrice', {
      params: { userLimit, billingType, countryIsoCode },
      fields: [
        'amountDueToday',
        'discountedAmountDueToday',
        'amountTotal',
        'discountedAmountTotal',
        'currencyCode',
        'id',
        'unitPrice',
        'promotionId',
      ],
    });
  }

  static getEnterpriseSelfServeContractProductPrice({
    userLimit,
    billingType,
    enterprisePromotionId,
    termInstallmentsTotal,
    userIdOpt = undefined,
  }: GetEnterpriseSelfServeContractProductPriceParams) {
    let _billingType = '';

    if (billingType === 1) _billingType = 'ONE_TIME';
    if (billingType === 4) _billingType = 'QUARTERLY';

    const params = {
      userLimit,
      billingType: _billingType,
      termInstallmentsTotal,
      // Empty iso code allows the server to determine based on IP for geo pricing
      countryIsoCode: '',
      // We only support USD for now
      currencyCode: 'USD',
    } as GetEnterpriseSelfServeContractProductPriceQueryParams;

    if (typeof userIdOpt !== 'undefined') {
      params.userIdOpt = userIdOpt;
    }

    if (enterprisePromotionId) {
      params.enterprisePromotionId = enterprisePromotionId;
    }

    return this.finder('getEnterpriseSelfServeContractProductPrice', {
      params,
      fields: [
        'unitPrice',
        'rawLocalAmountTotal',
        'discountPercent',
        'countryIsoCode',
        'actualLocalAmountDueToday',
        'actualLocalAmountTotal',
        'rawLocalAmountDueToday',
        'actualLocalDiscountedAmount',
        'fxRateId',
        'rawAmountTotal',
        'rawAmountDueToday',
        'id',
        'currencyCode',
      ],
    });
  }
}

export default EnterpriseSelfServeContractProductPrices;
